







import { defineComponent } from "@vue/composition-api";
import { cards } from "./config";
import FeatureCard from "./FeatureCard.vue";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "FeaturesBlock",
  components: { FeatureCard, LandingContainer },
  setup() {
    return {
      cards,
    };
  },
});
